import styled from "styled-components";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { borderRadius, borderWidth } from "../../../design-system/tokens/borders";
import { typographyMixin } from "../../../design-system/tokens/typography";

export {
  CountBadge,
  EmptyHint,
  IconSlot,
  SectionHeader,
  SectionTitle,
  TabRoot,
} from "../KgInspectorLinksTab/KgInspectorLinksTab.styles";

export const SummaryCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[1]};
  padding: ${spacing[3]};
  background-color: ${rawColors.structural[100]};
  border: ${borderWidth[1]} solid ${rawColors.stroke[200]};
  border-radius: ${borderRadius.lg};
`;

export const SummaryTitle = styled.span`
  ${typographyMixin("body", 2)}
  color: ${rawColors.text.highEmphasis};
`;

export const SummaryMeta = styled.span`
  ${typographyMixin("caption", 4)}
  color: ${rawColors.text.mediumEmphasis};
`;

export const ActivityBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[4]};
`;
